<template>
    <div class="partners-filter">
        <!-- <div class="partners-filter__date"> -->
            <!--            <datetime class="short-text theme-primary partners-filter__input orders-filter__input_green orders-filter__input_baseHeight"-->
            <!--                      type="datetime"-->
            <!--                      v-model="dateFrom"-->
            <!--                      input-class="date-input"-->
            <!--                      :phrases="{ok: $t('request.continue'), cancel: $t('request.exit')}"-->
            <!--                      :format="{ weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' }"-->
            <!--                      :minute-step="10"-->
            <!--                      :placeholder="$t('request.dateHolder')"></datetime>-->
            <!--            <datetime class="short-text theme-primary partners-filter__input orders-filter__input_green orders-filter__input_baseHeight"-->
            <!--                      type="datetime"-->
            <!--                      v-model="dateTill"-->
            <!--                      input-class="date-input"-->
            <!--                      :phrases="{ok: $t('request.continue'), cancel: $t('request.exit')}"-->
            <!--                      :format="{ weekday: 'short', year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: '2-digit' }"-->
            <!--                      :minute-step="10"-->
            <!--                      :placeholder="$t('request.dateHolder')"></datetime>-->
        <!-- </div> -->
        <h2>{{ $t('navigation.partners') }}</h2>

        <div class="partners-filter__search orders-filter_width">
            <search @searchData='search'/>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: 'partners-filter',
    computed: {
        dateFrom: {
            get() {
                return new Date()
            },
            set(v) {
                return v
            },
        },
        dateTill: {
            get() {
                return new Date()
            },
            set(v) {
                return v
            },
        },
    },
    methods: {
        ...mapActions({
            fetch: 'partners/fetch',
        }),
        search(v) {
            this.fetch({ search: v })
        },
    },
}
</script>

<style lang="scss" scoped>
    .partners-filter {
        margin: 20px 0 15px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;

        h2 {
            margin: 0;
            font-size: 32px;
            color: #4d4d4d;
        }

        &__date {
            display: flex;
            margin-bottom: 10px;
        }

        &__input {
            border-radius: 8px;
            background-color: #ffffff;
            border: 1px solid #e0e0e0;
            overflow: hidden;
            font-family: "SFUIDisplay-Regular";
            font-size: 14px;
            color: #61422d;
            padding-left: 13px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            -webkit-transition: 0.5s;
            transition: 0.5s;
            margin-top: 5px;
            outline: none;
            width: 170px;
            margin-right: 30px;
            height: 100%;
            display: flex;
            align-items: center;
        }
    }
</style>
